import { t } from "i18next";

import { RoutesApiConst } from "../constants";
import { ICreateViewDto, SimpleResult, ViewDto } from "../dto";
import { getCompanyId } from "../helpers";
import { apiDelete, apiGetAll, apiPatch, apiPost } from "./generic-api";

export class ViewApi {
  static async create(viewDto: ICreateViewDto): Promise<ViewDto | undefined> {
    const companyId = getCompanyId();

    if (companyId) {
      const response = await apiPost<ViewDto>(RoutesApiConst.views, {
        body: { ...viewDto, companyId },
      });
      return response;
    } else {
      throw new Error(t("errors.noCompanyIdFound"));
    }
  }

  static async update(
    viewId: number,
    data: Partial<ViewDto>,
  ): Promise<ViewDto | undefined> {
    const companyId = getCompanyId();

    if (companyId) {
      const response = await apiPatch<ViewDto>(
        `${RoutesApiConst.views}/${viewId}`,
        {
          body: { ...data, companyId },
        },
      );
      return response;
    } else {
      throw new Error(t("errors.noCompanyIdFound"));
    }
  }

  static async getAllForEntity({
    entityId,
    companyId: companyIdParam,
  }: {
    entityId: number;
    companyId?: number;
  }): Promise<ViewDto[] | undefined> {
    const companyId = companyIdParam ?? getCompanyId();

    if (companyId) {
      const params = new URLSearchParams({
        entityId: String(entityId),
        companyId: String(companyId),
      });

      return apiGetAll<ViewDto>(`${RoutesApiConst.views}?${params.toString()}`);
    } else {
      throw new Error(t("errors.noCompanyIdFound"));
    }
  }

  static async remove(
    viewId: number,
  ): Promise<SimpleResult<ViewDto> | undefined> {
    return apiDelete<SimpleResult<ViewDto>>(
      `${RoutesApiConst.views}/${viewId}`,
    );
  }
}
